<template>
  <div>
    <v-card elevation="0" :disabled="loading" :loading="loading">
      <div v-if="attach && attachVisible" class="py-4 px-4">
        <v-card outlined class="px-4 py-4">
          <v-select v-model="attachmentId" :items="attachables" outlined required dense />
          <v-btn color="primary" dark depressed @click="attachResource">Attach</v-btn>
        </v-card>
      </div>
      <v-simple-table class="mb-4">
        <thead>
          <tr>
            <slot name="headings" />
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in items.data">
            <tr :key="item.id">
              <slot :item="item" />
              <td>
                <div class="d-flex justify-end">
                  <v-btn v-if="showView" icon text @click="viewResource(item)">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn v-if="showEdit" icon text @click="editResource(item)">
                    <v-icon>create</v-icon>
                  </v-btn>
                  <v-btn v-if="showDelete" icon text @click="deleteResource(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
      <v-card-actions>
        <div class="d-flex align-center" style="width: 100%;">
          <v-pagination
            v-if="hidePagination"
            v-model="page"
            :total-visible="14"
            :length="Math.ceil(items.pagination.total / items.pagination.perPage)"
            style="flex: 1;"
            @input="page => $emit('paginate', page)"
          />
          <v-btn v-if="attach" color="primary" dark depressed @click="toggleAttachVisible">
            Attach Resource
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ResourceList',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    attach: {
      type: Boolean,
      default: false,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    attachItems: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Object,
      required: true,
    },
    showView: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      page: 1,
      attachmentId: null,
      attachVisible: false,
    }
  },
  computed: {
    attachables() {
      return this.attachItems.map(item => ({ text: item.name, value: item.id }))
    },
  },
  methods: {
    viewResource(item) {
      this.$emit('viewResource', item)
    },
    editResource(item) {
      this.$emit('editResource', item)
    },
    deleteResource(item) {
      this.$emit('deleteResource', item)
    },
    attachResource() {
      this.$emit('attachResource', this.attachmentId)
      this.toggleAttachVisible()
    },
    toggleAttachVisible() {
      this.attachVisible = !this.attachVisible
    },
  },
}
</script>
